import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useReadUserProfile } from '@/api/user-manager'
import { Loading } from '@/components'
import { routes } from '@/router'
import { UserProfile } from '@/types'
import { ProfileStep, profileStepRedirect } from './profile-steps'

export function ProfileStepFrame({
  step,
  children,
}: {
  step: ProfileStep
  children: (user: UserProfile) => ReactNode
}) {
  const { data: user, isLoading } = useReadUserProfile()

  if (isLoading || !user) return <Loading />

  const redirect = profileStepRedirect(step, user)
  if (redirect === 'home') return <Navigate to={routes.home} replace />
  if (redirect) {
    return <Navigate to={routes.session.profile[redirect]} replace />
  }

  return children(user)
}
